module.exports = __webpack_public_path__ + "media/img/pages/companies/fenaco-new-481c9af42d32dfcfe51dbbb4f60394ff.png";